import React from 'react';
import { Row, Col, Card, Collapse } from 'react-bootstrap';

import { render_marked_text } from '../utils/HiddenText';

function ContentDepth({
	analysis_results,
	show_depth,
	set_show_depth
}){

	const render_content_depth_section = ()=> {
		const data = analysis_results.content_depth;
		if(!data){
			return;
		}

		return (
			<Card className="analysis-results-card content-depth-card">
				<h3 className="content-depth-title" onClick={()=>set_show_depth(!show_depth)} style={{cursor:'pointer'}}>
					Content Depth {show_depth ? "▲" : "▼"}
				</h3>
				<p className="content-depth-desc">
					How thoroughly this page develops its ideas, avoids repetition, and provides meaningful, well-explained information.
				</p>

				<Collapse in={show_depth}>
				<div>
				<Row>
					{/* LEFT BOOLEAN COLUMN */}
					<Col md={4}>
						<div className="depth-bool-list">
							<div className={
								"depth-bool-item " +
								(data.meaningful_depth_present ? "depth-bool-true" : "depth-bool-false")
							}>
								<span className="depth-bool-icon"></span>
								<span className="depth-bool-label">Meaningful depth present</span>
							</div>
						</div>
					</Col>

					{/* RIGHT COLUMN DETAILS */}
					<Col md={8}>
						{(Array.isArray(data.hidden_sections) && (data.hidden_sections.length > 0)) && (
							<div className="depth-section-group">
								<div className="depth-section-heading">Sections in text a visitor cannot see</div>
								{data.hidden_sections.map((text, index)=>(
									<div key={index} className="depth-text-box">{render_marked_text(text, analysis_results)}</div>
								))}
							</div>
						)}

						{(data.shallow_sections.length > 0) && (
							<div className="depth-section-group">
								<div className="depth-section-heading">Shallow sections</div>
								{data.shallow_sections.map((text, index)=>(
									<div key={index} className="depth-text-box">{render_marked_text(text, analysis_results)}</div>
								))}
							</div>
						)}

						{(Array.isArray(data.duplicate_sections) && (data.duplicate_sections.length > 0)) && (
							<div className="depth-section-group">
								<div className="depth-section-heading">Sections that repeat an earlier section</div>
								{data.duplicate_sections.map((text, index)=>(
									<div key={index} className="depth-text-box">{render_marked_text(text, analysis_results)}</div>
								))}
							</div>
						)}

						{(Array.isArray(data.shallow_faq_answers) && (data.shallow_faq_answers.length > 0)) && (
							<div className="depth-section-group">
								<div className="depth-section-heading">FAQ answers too short to reuse</div>
								{data.shallow_faq_answers.map((text, index)=>(
									<div key={index} className="depth-text-box">{render_marked_text(text, analysis_results)}</div>
								))}
							</div>
						)}

						{(data.repetitive_phrases.length > 0) && (
							<div className="depth-section-group">
								<div className="depth-section-heading">Repetitive phrases</div>
								{data.repetitive_phrases.map((text, index)=>(
									<div key={index} className="depth-text-box">{text}</div>
								))}
							</div>
						)}

						{(data.depth_notes.length > 0) && (
							<div className="depth-section-group">
								<div className="depth-section-heading">Depth notes</div>
								{data.depth_notes.map((text, index)=>(
									<div key={index} className="depth-text-box">{text}</div>
								))}
							</div>
						)}
					</Col>
				</Row>
				</div>
				</Collapse>
			</Card>
		);
	};

	if(!analysis_results || !analysis_results.content_depth){
		return null;
	}

	return render_content_depth_section();
}

export default ContentDepth;
